import { format as formatDateFns } from 'date-fns';
import type { FormatterFactory } from '../types';
import { toDate } from './date';

export interface DateTimeOptions {
  format?: string;
}

export const datetime: FormatterFactory = (options: DateTimeOptions = {}) => ({
  toText: (value) => {
    const parsed = toDate(value);
    if (!parsed) {
      return '';
    }
    if (options.format) {
      return formatDateFns(parsed, options.format);
    }
    const i18n = (globalThis as any).$app?.i18n;
    return i18n
      ? i18n.formatDatetime(parsed)
      : formatDateFns(parsed, 'yyyy-MM-dd HH:mm');
  },

  toValue: (value) => toDate(value),
});
